const NORWEGIAN_DATE_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Oslo',
});

const NORWEGIAN_DATE_NO_YEAR_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    timeZone: 'Europe/Oslo',
});

const NORWEGIAN_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    minute: '2-digit',
    hour: 'numeric',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Oslo',
});

const NORWEGIAN_DATE_TIME_NO_YEAR_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    minute: '2-digit',
    hour: 'numeric',
    day: 'numeric',
    month: 'long',
    timeZone: 'Europe/Oslo',
});

const NORWEGIAN_TIME_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    minute: '2-digit',
    hour: 'numeric',
    timeZone: 'Europe/Oslo',
});

const NORWEGIAN_MONTH_YEAR_FORMATTER = new Intl.DateTimeFormat('nb-NO', {
    month: 'short',
    year: 'numeric',
    timeZone: 'Europe/Oslo',
});

export type FormattingOption = 'date' | 'month_year' | 'date_time' | 'date_same_year' | 'time' | 'time_same_day';

export default function getFormattedDate(dateText: string | undefined, type: FormattingOption = 'date') {
    if (!dateText) return null;

    const date = new Date(dateText);

    switch (type) {
        case 'date_time':
            return NORWEGIAN_DATE_TIME_FORMATTER.format(date);
        case 'date_same_year':
            return date.getFullYear() === new Date().getFullYear()
                ? NORWEGIAN_DATE_NO_YEAR_FORMATTER.format(date)
                : NORWEGIAN_DATE_FORMATTER.format(date);
        case 'date':
            return NORWEGIAN_DATE_FORMATTER.format(date);
        case 'month_year':
            return NORWEGIAN_MONTH_YEAR_FORMATTER.format(date);
        case 'time':
            return NORWEGIAN_TIME_FORMATTER.format(date);
        case 'time_same_day':
            return date.toDateString() === new Date().toDateString()
                ? NORWEGIAN_TIME_FORMATTER.format(date)
                : date.getFullYear() === new Date().getFullYear()
                  ? NORWEGIAN_DATE_TIME_NO_YEAR_FORMATTER.format(date)
                  : NORWEGIAN_DATE_TIME_FORMATTER.format(date);
        default:
            return null;
    }
}
